var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty",style:(("background:url(" + _vm.bgImg + ") no-repeat"))},[_c('img',{staticClass:"empty-img",attrs:{"src":_vm.src,"alt":"暂无数据"}}),_vm._v(" "),_c('span',{staticClass:"empty-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b6e0a20","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/empty/empty.vue
// module id = null
// module chunks = 